import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
export function CTASection() {
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Form submitted');
    // In a real app, handle form submission here
  };
  return <section id="contact" className="py-24 md:py-32 bg-background" data-id="element-29">
      <div className="max-w-3xl mx-auto px-6 md:px-12 text-center" data-id="element-30">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} viewport={{
        once: true
      }} data-id="element-31">
          <h2 className="text-4xl md:text-6xl font-serif mb-6" data-id="element-32">
            Ready to Anthropify?
          </h2>
          <p className="text-lg text-neutral-600 mb-12" data-id="element-33">
            Book a discovery call to discuss how we can transform your
            organization's efficiency.
          </p>

          <form onSubmit={handleSubmit} className="bg-white p-8 rounded-3xl border border-neutral-200 text-left shadow-sm" data-id="element-34">
            <div className="grid md:grid-cols-2 gap-6 mb-6" data-id="element-35">
              <div data-id="element-36">
                <label className="block text-sm font-medium text-neutral-700 mb-2" data-id="element-37">
                  Name
                </label>
                <input type="text" required className="w-full px-4 py-3 rounded-xl border border-neutral-200 focus:outline-none focus:ring-2 focus:ring-accent/20 focus:border-accent transition-colors bg-white" placeholder="Jane Doe" data-id="element-38" />
              </div>
              <div data-id="element-39">
                <label className="block text-sm font-medium text-neutral-700 mb-2" data-id="element-40">
                  Work Email
                </label>
                <input type="email" required className="w-full px-4 py-3 rounded-xl border border-neutral-200 focus:outline-none focus:ring-2 focus:ring-accent/20 focus:border-accent transition-colors bg-white" placeholder="jane@company.com" data-id="element-41" />
              </div>
              <div data-id="element-42">
                <label className="block text-sm font-medium text-neutral-700 mb-2" data-id="element-43">
                  Company
                </label>
                <input type="text" required className="w-full px-4 py-3 rounded-xl border border-neutral-200 focus:outline-none focus:ring-2 focus:ring-accent/20 focus:border-accent transition-colors bg-white" placeholder="Acme Corp" data-id="element-44" />
              </div>
              <div data-id="element-45">
                <label className="block text-sm font-medium text-neutral-700 mb-2" data-id="element-46">
                  Company Size
                </label>
                <select className="w-full px-4 py-3 rounded-xl border border-neutral-200 focus:outline-none focus:ring-2 focus:ring-accent/20 focus:border-accent transition-colors bg-white appearance-none" data-id="element-47">
                  <option data-id="element-48">1-50 employees</option>
                  <option data-id="element-49">51-200 employees</option>
                  <option data-id="element-50">201-1000 employees</option>
                  <option data-id="element-51">1000+ employees</option>
                </select>
              </div>
            </div>
            <div className="mb-8" data-id="element-52">
              <label className="block text-sm font-medium text-neutral-700 mb-2" data-id="element-53">
                Message (Optional)
              </label>
              <textarea rows={3} className="w-full px-4 py-3 rounded-xl border border-neutral-200 focus:outline-none focus:ring-2 focus:ring-accent/20 focus:border-accent transition-colors bg-white resize-none" placeholder="Tell us about your current AI initiatives..." data-id="element-54" />
            </div>
            <button type="submit" className="w-full inline-flex items-center justify-center px-6 py-4 text-base font-medium text-white bg-foreground hover:bg-accent transition-colors rounded-xl group" data-id="element-55">
              Request Consultation
              <ArrowRightIcon className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" data-id="element-56" />
            </button>
          </form>
        </motion.div>
      </div>
    </section>;
}